import mqtt from 'websocket-hub'
import { parseQuery } from '@common/utils/query'

const query = parseQuery(window.location.search) || {}

const devComponentHost = query.devComponentHost || localStorage.getItem('devComponentHost') || '127.0.0.1'
const devComponentPort = query.devComponentPort || localStorage.getItem('devComponentPort') || '8333'

localStorage.setItem('devComponentHost', devComponentHost)
localStorage.setItem('devComponentPort', devComponentPort)

export default {
    cookies: {},
    // 应用信息
    app: {},
    appSetting: {},
    validPurview: {},
    classifyComponents: {},
    components: [],
    presetedComponents: [],
    customizeComponents: [],
    specialComponents: [],
    builtinComponents: [],
    bizComponents: [],
    localComponents: [],
    formComponents: [],
    pages: null,
    systemPages: [],
    // 配置
    hasConfApi: false,
    isAllPublish: true,
    confList: [],
    systemConfList: [],
    userList: [],
    appList: [],
    templateList: [],
    // iconfont
    icons: [],
    iconUrl: '',
    // 组图标激活状态时，class 后缀
    iconSuffix: '',
    mqtt,
    globalLoading: false,
    refreshFalg: false,
    desingConf: {},
    businessEnv: {},
    lockedPageId: {},
    lockerLoading: {},
    firstLockerLoaded: false,
    assignedPageLoading: false,
    devComponentHost,
    devComponentPort,
    tabsMessageCount: {
        service: 0,
    },
    confLoading: true,
}
